import { v4 as uuidv4 } from "uuid";

export default function getGuid(): string {
  return uuidv4();
}
